import * as Request from '../../request'
import * as Constants from './constants'

export const logoutUser = () =>
Request.requestActionCreator<any>(Constants.USER_LOGOUT)({
  method: 'GET',
  url: `/auth/logout` ,
})



// WEBPACK FOOTER //
// ./src/pages/logout/actions.ts